import React from 'react';
import { IIconProps } from './add';

interface IIconInvisible extends IIconProps {
  width?: string;
  height?: string;
}

export const IconInvisible = ({
  style = {},
  cy,
  height = '13',
  width = '14',
}: IIconInvisible) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`InvisibleIcon${cy}`}
    >
      <path
        d="M7.00291 3.29167C8.61291 3.29167 9.91958 4.59834 9.91958 6.20834C9.91958 6.5875 9.84374 6.94334 9.70958 7.27584L11.4129 8.97917C12.2937 8.24417 12.9879 7.29334 13.4137 6.20834C12.4046 3.6475 9.91374 1.83334 6.99708 1.83334C6.18041 1.83334 5.39874 1.97917 4.67541 2.24167L5.93541 3.50167C6.26791 3.3675 6.62374 3.29167 7.00291 3.29167ZM1.16958 1.69917L2.76791 3.2975C1.79958 4.05 1.04124 5.05334 0.586243 6.20834C1.59541 8.76917 4.08624 10.5833 7.00291 10.5833C7.90708 10.5833 8.77041 10.4083 9.55791 10.0933L9.80291 10.3383L11.5121 12.0417L12.2529 11.3008L1.91041 0.958336L1.16958 1.69917ZM4.39541 4.925L5.29958 5.82917C5.27041 5.95167 5.25291 6.08 5.25291 6.20834C5.25291 7.17667 6.03458 7.95834 7.00291 7.95834C7.13124 7.95834 7.25958 7.94084 7.38208 7.91167L8.28624 8.81584C7.89541 9.00834 7.46374 9.125 7.00291 9.125C5.39291 9.125 4.08624 7.81834 4.08624 6.20834C4.08624 5.7475 4.20291 5.31584 4.39541 4.925ZM6.90958 4.47L8.74708 6.3075L8.75874 6.21417C8.75874 5.24584 7.97708 4.46417 7.00874 4.46417L6.90958 4.47Z"
        fill="#BBC1C9"
      />
    </svg>
  );
};
